import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import * as AiIcons from "react-icons/ai";
import UpdateAreaN2 from './UpdateAreaN2';
import { FaEdit } from "react-icons/fa";
import UpdatePosicion from './UpdatePosicion';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>ID posición</th>
        <th style={{width:'20%'}}>Nombre posición</th>
        <th className='d-none d-sm-table-cell' style={{width:'50%'}}>Descripción posición</th>
        <th style={{width:'5%'}}>{props.mode==0?'Editar ':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  
  if (props.listOfPosiciones) {
    
    const rows = props.listOfPosiciones.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.nombreposicion}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.descripcionposicion}
          </td>             

          <td align='center'>  
            {(props.mode==0) &&
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdatePosicion 
                  editposicion = {row}
                  id = {row.id}
                  nombreposicion = {row.nombreposicion}
                  descripcionposicion = {row.descripcionposicion}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.nombreposicion,row.descripcionposicion);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td>                   
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const PosicionsList = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody mode={props.mode} handleClose={props.handleClose} onSelected={props.onSelected} arean2id={props.arean2id} listOfPosiciones={props.listOfPosiciones} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default PosicionsList;